import { RolexContainer } from './Container'
import { Text } from '@components/rolex-ui/Text'
import { cn } from '@lib/cn'
import { FC } from 'react'

type RolexQuoteProps = {
  className?: string
  quote: string
  author: string
}

export const RolexQuote: FC<RolexQuoteProps> = ({ quote, author, className }) => {
  return (
    <RolexContainer
      className={cn(
        `mb-[60px] grid w-full grid-cols-6 gap-2 md:grid-cols-12 lg:mb-[90px]`,
        className,
      )}
    >
      <div className="col-span-6 flex flex-col items-start md:col-span-8 md:col-start-3 lg:col-span-6 lg:col-start-4">
        <p className="mb-5 font-rolexQuote text-[30px] leading-[1.1] lg:text-[50px]">{quote}</p>
        <Text variant="body20" weight="light">
          {author}
        </Text>
      </div>
    </RolexContainer>
  )
}
